import { Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";

type Props = {
  onClick?: () => void;
  disabled?: boolean;
};

export const CalculatePriceButton = ({ onClick, disabled }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <Button
      className={styles.calculateButton}
      variant="contained"
      color="primary"
      onClick={onClick}
      disabled={disabled}
    >
      {t("WORK_ORDER.QUOTATION.ACTIONS.CALCULATE_PRICE")}
    </Button>
  );
};
